import React, { FC } from 'react';
import { Form } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { Input } from '../../../system/components/Input';

interface Props {
  form: WrappedFormUtils;
  initialValue?: string;
}

export const InputSlug: FC<Props> = ({ form, initialValue }): JSX.Element => (
  <Form.Item label="URL Slug">
    {form.getFieldDecorator('slug', {
      initialValue,
      rules: [{ required: false }],
    })(<Input allowClear placeholder="URL Slug" />)}
  </Form.Item>
);
